import React from 'react';
import { Switch, withRouter, RouteComponentProps } from "react-router-dom";
import { PrivateRoute } from './PrivateRoute';
import Welcome from './Welcome';
import { connect } from 'react-redux';
import { IActions, actionCreator } from '../Auth0/store/actions/creators';
import { IApplicationState } from '../../store/ApplicationState';
import { IState } from '../Auth0/store/state';
import { Contacts } from '../../scenes/contacts/Contacts';
import { Trainers } from '../../scenes/trainers/Trainers';
import { Tags } from '../../scenes/tags/Tags';
import { PostEditContainer } from '../../scenes/edit/PostEditContainer';
import { PostSending } from '../../scenes/drafts/Container';
import { PostSent } from '../../scenes/sent/Container';
import { ChatContainer } from '../../scenes/chat/ChatContainer';
import { Rooms } from '../../scenes/room/Room';
import { Reservations } from '../../scenes/reservation/Reservation';
import { ActivitiesContainer } from '../../scenes/activities/ActivitiesContainer';
import { ActivityReservations } from '../../scenes/activityReservations/activityReservations';
import { Reminders } from '../../scenes/reminders/Reminders';
import { Subscriptions } from '../../scenes/subscriptions/Subscriptions';
import { Accesses } from '../../scenes/accesses/Accesses';
import { Birthdays } from '../../scenes/birthdays/Birthdays';
import { MedicalExaminations } from '../../scenes/medicalExaminations/MedicalExaminations';

export const mapStateToPropsInitial = (state: IApplicationState) => state.auth
const mapStateToProps = (state: IApplicationState, ownp) => ({ ...state.auth, ...ownp });
export const mapDispatchToProps = (dispatch: any) => actionCreator(dispatch);

export interface IProps extends IState, IActions, RouteComponentProps {
    children?: any;
}

const comp = (props: IProps) => {
    return (<Switch>
        <PrivateRoute key="a1" path="/private/Tags" Component={Tags} />
        <PrivateRoute key="a2" path="/private/Tags/:id" Component={Tags} />
        <PrivateRoute key="a3" path="/private/Contacts" exact Component={Contacts} />
        <PrivateRoute key="a4" path="/private/Contacts/:id" Component={Contacts} />
        <PrivateRoute key="a5" path="/private/Trainers" exact Component={Trainers} />
        <PrivateRoute key="a6" path="/private/Reminders" exact Component={Reminders} />
        <PrivateRoute key="a7" path="/private/Subscriptions" exact Component={Subscriptions} />
        <PrivateRoute key="a8" path="/private/new" exact Component={PostEditContainer} />
        <PrivateRoute key="a9" path="/private/edit/:id" Component={PostEditContainer} />
        <PrivateRoute key="b1" path="/private/drafts" exact Component={PostSending} />
        <PrivateRoute key="b2" path="/private/sent" exact Component={PostSent} />
        <PrivateRoute key="b3" path="/private/Chat" exact Component={ChatContainer} />
        <PrivateRoute key="b4" path="/private/Chat/:id" Component={ChatContainer} />
        <PrivateRoute key="b5" path="/private/Room" exact Component={Rooms} />
        <PrivateRoute key="b6" path="/private/Accesses" exact Component={Accesses} />
        <PrivateRoute key="b7" path="/private/Activities" exact Component={ActivitiesContainer} />
        <PrivateRoute key="b8" path="/private/Reservation" exact Component={Reservations} />
        <PrivateRoute key="b9" path="/private/ActivityReservations" exact Component={ActivityReservations} />
        <PrivateRoute key="c1" path="/private/Birthdays" exact Component={Birthdays} />
        <PrivateRoute key="c2" path="/private/MedicalExaminations" exact Component={MedicalExaminations} />
        <PrivateRoute key="c3" path="/" exact Component={Welcome} />
    </Switch>)
}
export const LayoutRoutes = withRouter(connect(mapStateToProps, mapDispatchToProps)(comp))